import type { ReactNode } from "react"
import { AdminLayout } from "./AdminLayout"
import { ErrorCallout } from "@rawa/ui/ErrorCallout"
import { ProtectedRoute } from "./ProtectedRoute"
import { SERVER_UNREACHABLE_MESSAGE } from "./serverUnreachable"

/**
 * The guard every `/admin` route uses: the admin chrome, the staff session check,
 * and an unreachable-server message in the admin surface's own error treatment.
 *
 * It exists as one component rather than an `AdminLayout` and a `ProtectedRoute`
 * paired at each route because the pairing has a wrong order that still compiles.
 * Nesting the guard inside the layout put `SadPage` — a whole client-facing page,
 * logo header and Safe Exit button included — inside the admin content area.
 * Composing them here means an admin route cannot express that.
 */
export function AdminProtectedRoute({
  children,
  wide,
}: {
  children: ReactNode
  wide?: boolean
}) {
  return (
    <AdminLayout wide={wide}>
      <ProtectedRoute
        unreachable={<ErrorCallout>{SERVER_UNREACHABLE_MESSAGE}</ErrorCallout>}
      >
        {children}
      </ProtectedRoute>
    </AdminLayout>
  )
}
